import React from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import { SerpStatusGq } from '../../../../../../graphql/projects/models/SerpStatusGq';
import { formatNumber } from '../../../../../../logic/otherUtilities/formatting/formatNumber';
import VoxelLoadingSpinner from '../../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../../voxel/DataTable/VoxelDataTableCell';

export interface TableCellTrafficProps {
  rankCtrValues?: Record<string, number>;
  rank?: number;
  dataExists?: boolean;
  keyword: ProjectKeywordGq;
  borderRight?: boolean;
  serpStatus?: SerpStatusGq;
}

const TableCellTraffic: React.FC<TableCellTrafficProps> = ({
  rank,
  rankCtrValues,
  keyword,
  dataExists,
  borderRight,
  serpStatus,
}) => {
  if ((!dataExists && serpStatus === SerpStatusGq.PROCESSING) || keyword.fetchingNewVolume)
    return (
      <VoxelDataTableCell align="right" className={`${borderRight && 'border-r'}`}>
        <div className="w-full flex flex-row justify-end">
          <VoxelLoadingSpinner />
        </div>
      </VoxelDataTableCell>
    );

  if (!dataExists)
    return (
      <VoxelDataTableCell
        align="right"
        className={`${borderRight && 'border-r'}`}
      />
    );

  const traffic = rank ? (rankCtrValues[rank] / 100) * keyword?.volume : 0;

  return (
    <VoxelDataTableCell align="right" type='number' className={`font-medium pl-0 ${borderRight && 'border-r'}`}>
      {formatNumber(traffic, 0)}
    </VoxelDataTableCell>
  );
};

export default TableCellTraffic;
